import React from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@linaria/react';
import { colors } from '@spaceshipapp/cambridge';
import logo from '../../assets/images/logo-b.svg';

const PublicNavbar = () => {
  return (
    <Header>
      <div className="container">
        <Link to="/login">
          <img src={logo} alt="Spaceship Pro" height={33} width={222} />
        </Link>
      </div>
    </Header>
  );
};

const Header = styled.header`
  padding: 1.5em 0;
  background-color: ${colors.brandSecondary};
  border-bottom: 1px solid ${colors.border};
`;

export default PublicNavbar;
